import { breakpoints } from '../global/breakpoints';
import { palette } from '../global/palette';
import { typography } from '../global/typography';
import type { ComponentOverride } from '../types';

export const MuiTab: ComponentOverride<'MuiTab'> = {
  MuiTab: {
    styleOverrides: {
      root: {
        ...typography.subtitle1,
        color: palette.grey[500],
        overflow: 'visible',
        minHeight: 27,
        paddingLeft: '18px',
        paddingRight: '18px',
        [breakpoints.down('md')]: {
          paddingLeft: '10px',
          paddingRight: '4px',
        },
        borderBottom: `1px solid ${palette.grey[400]}`,
        '&:before': {
          content: "''",
          position: 'absolute',
          top: '0px',
          left: '0px',
          right: '0px',
          bottom: '0px',
          borderBottom: `2px solid transparent`,
        },

        '&:hover::before': {
          borderColor: `${palette.primary.main}` /* Change the border color on hover */,
        },

        '&:hover': {
          color: palette.common.black,
          '& img': {
            opacity: '1',
          },
          '& .gatsby-image-wrapper': {
            opacity: '1',
          },
        },
        '&.Mui-selected': {
          color: palette.common.black,
        },
        '&.Mui-selected:before': {
          borderColor: `${palette.primary.main}`,
        },
        '& img': {
          opacity: '0.6',
        },
        '& .gatsby-image-wrapper': {
          opacity: '0.6',
        },

        '&.Mui-selected .gatsby-image-wrapper': {
          opacity: '1',
        },

        '&.Mui-selected img': {
          opacity: '1',
        },
        '&.Mui-disabled': {
          color: '#e6e7e8',
        },
      },
    },
  },
};
